import React from 'react';
import image1 from "../../images/LudoBlue/Gemini_Generated_Image_upiv4nupiv4nupiv (1).png";
import image2 from "../../images/LudoBlue/Gemini_Generated_Image_s1277bs1277bs127.png";
import image3 from "../../images/LudoBlue/Gemini_Generated_Image_xe3ntrxe3ntrxe3n.png";

import { useLocation } from "react-router-dom";
import { useEffect } from "react";
function ScrollToAnchor() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  return null;
}

const Animations = () => {
    return (
        <div className="container my-5">
<ScrollToAnchor />
            {/* Section 1: Jeu pour Tous */}
            <section id="tous">
            <div className="row align-items-center mb-5"> {/* Nouvelle ligne pour la carte et l'image */}
                <div className="col-md-6 order-md-1"> {/* Ordre 1 pour l'image sur grand écran */}
                    <img src={image1} alt="Enfants jouant en intérieur" className="img-fluid rounded shadow-sm my-3" />
                </div>
                <div className="col-md-6 order-md-2"> {/* Ordre 2 pour la carte sur grand écran */}
                    <div className="card shadow-sm h-100"> {/* h-100 pour que la carte prenne toute la hauteur */}
                        <div className="card-body p-4 p-md-5">
                            <h2 className="card-title text-center mb-4">Le Jeu pour Tous : Notre Engagement pour l'Inclusion</h2>
                            <p className="lead text-center">
                                Chez LudoBlue, le mot <strong>"tous"</strong> est au centre de nos préoccupations. Nous sommes convaincus que chacun, quelles que soient ses capacités, doit pouvoir accéder au plaisir de jouer.
                            </p>
                            <p>
                                C'est pourquoi nous avons développé une collection spécifique et portons une attention particulière à l'accueil de tous les publics.
                            </p>

                            <h4 className="mt-4">Notre collection adaptée :</h4>
                            <ul>
                                <li><strong>Jeux sensoriels :</strong> Des jeux qui stimulent le toucher, l'ouïe ou l'odorat, parfaits pour les tout-petits ou les personnes avec des troubles sensoriels.</li>
                                <li><strong>Jeux à gros caractères :</strong> Des versions adaptées de jeux classiques pour les personnes malvoyantes.</li>
                                <li><strong>Jeux coopératifs :</strong> Idéals pour les personnes qui n'aiment pas la compétition directe, ils favorisent l'entraide et la communication.</li>
                                <li><strong>Matériel de jeu manipulable :</strong> Des pièces faciles à prendre en main pour les personnes ayant des difficultés de motricité fine.</li>
                            </ul>

                            <p className="mt-4">
                                Notre équipe est formée pour vous conseiller et vous orienter vers les jeux les plus adaptés à vos besoins. N'hésitez pas à nous solliciter pour préparer votre visite ou pour toute question sur l'accessibilité de nos locaux.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
</section>
            {/* Section 2: Grands Jeux */}
            <section id="grands-bois">
            <div className="row align-items-center mb-5">
                <div className="col-md-6">
                    <div className="card shadow-sm h-100">
                        <div className="card-body p-4 p-md-5">
                            <h2 className="card-title text-center mb-4">Voyez les choses en grand avec nos jeux surdimensionnés !</h2>
                            <p>
                                Apportez une touche d'originalité et de convivialité à vos événements avec notre collection de grands jeux en bois. Ces versions géantes de classiques indémodables amusent autant les participants que les spectateurs et garantissent une ambiance inoubliable.
                            </p>
                            <p>
                                Fabriqués artisanalement en bois, nos grands jeux sont robustes, esthétiques et faciles à prendre en main.
                            </p>

                            <div className="row mt-4">
                                <div className="col-md-6">
                                    <h4>Idéal pour :</h4>
                                    <ul>
                                        <li>Les mariages et fêtes de famille</li>
                                        <li>Les kermesses et fêtes d'école</li>
                                        <li>Les séminaires d'entreprise</li>
                                        <li>Les festivals et événements publics</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <h4>Quelques exemples de notre collection :</h4>
                                    <ul>
                                        <li>Puissance 4 Géant</li>
                                        <li>Jenga de la Tour Infernale</li>
                                        <li>Échecs de Jardin</li>
                                        <li>Mikado Géant</li>
                                        <li>Billard Hollandais</li>
                                    </ul>
                                </div>
                            </div>

                            <p className="mt-4 text-center">
                                <strong>Contactez-nous</strong> pour connaître les disponibilités et les tarifs de location. Nous pouvons vous proposer des forfaits adaptés à la taille et à la durée de votre événement.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <img src={image2} alt="Famille jouant à des jeux géants en extérieur" className="img-fluid rounded shadow-sm my-3" />
                </div>
            </div>
            </section>

            {/* Section 3: Jeux Coopératifs */}
            <section id="cooperatifs">
            <div className="row align-items-center mb-5">
                <div className="col-md-6 order-md-1">
                    <img src={image3} alt="Adultes jouant à un jeu de société coopératif" className="img-fluid rounded shadow-sm my-3" />
                </div>
                <div className="col-md-6 order-md-2">
                    <div className="card shadow-sm h-100">
                        <div className="card-body p-4 p-md-5">
                            <h2 to="ensemble" className="card-title text-center mb-4">Jouons ensemble, pas les uns contre les autres !</h2>
                            <p>
                                Et si on gagnait ou on perdait tous ensemble ? C'est le principe génial des jeux coopératifs ! Fini les disputes et les mauvais perdants, ici, l'union fait la force. Les joueurs ne s'affrontent pas, mais collaborent pour atteindre un objectif commun avant que le jeu lui-même ne gagne la partie.
                            </p>

                            <h4 className="mt-4">Les bienfaits des jeux coopératifs :</h4>
                            <ul>
                                <li><strong>Renforcement de l'esprit d'équipe :</strong> Il faut communiquer, s'écouter et prendre des décisions ensemble.</li>
                                <li><strong>Développement de l'empathie :</strong> On apprend à se mettre à la place des autres pour réussir.</li>
                                <li><strong>Baisse de l'anxiété liée à la compétition :</strong> L'ambiance est plus détendue et bienveillante.</li>
                                <li><strong>Valorisation de chaque joueur :</strong> Toutes les idées et actions comptent pour atteindre la victoire commune.</li>
                            </ul>

                            <p className="mt-4">
                                Notre ludothèque possède un large rayon de jeux coopératifs pour tous les âges et tous les goûts, du "Verger" pour les tout-petits à "Pandemic" pour les stratèges confirmés. Venez les découvrir !
                            </p>
                        </div>
                    </div>
                </div>
            </div>
</section>
        </div>
    );
};

export default Animations;